import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsersInvited = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 18,
	viewBox: "0 0 14 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3018_125329)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.42129 0.0326303C10.4781 -0.445308 12.6555 4.44577 9.48744 6.92541C7.18345 8.729 3.64637 7.46037 3.08017 4.64976C2.65085 2.51873 4.1788 0.296584 6.42129 0.0326303Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.6885 15.2445C10.8435 14.0676 10.0524 13.2969 8.84401 13.448C8.97425 12.712 8.5986 11.8249 7.76347 11.7273C7.43002 11.6885 6.48696 11.6855 6.16256 11.7343C5.39195 11.8501 5.02111 12.7625 5.15558 13.4486C3.94721 13.2981 3.1561 14.0682 3.31106 15.2451C1.06918 15.3239 -0.226022 14.7119 0.0326562 12.3246C0.246714 10.3452 2.1244 8.60158 4.15041 8.4452C5.49988 8.34115 9.32278 8.28883 10.5299 8.56454C12.2545 8.95842 13.7806 10.5986 13.9681 12.3246C14.2268 14.7107 12.9328 15.3239 10.6897 15.2451L10.6885 15.2445Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.96219 14.3064H9.44612C9.93393 14.3064 10.0443 16.2593 9.36592 16.2593H7.96219V17.7043C7.96219 18.1169 6.43182 18.0176 6.13938 17.8789C6.11526 17.8571 6.03747 17.7207 6.03747 17.7043V16.2593H4.63373C3.95538 16.2593 4.06573 14.3064 4.55354 14.3064H6.03747V12.7832C6.03747 12.6433 6.35524 12.5945 6.47403 12.5833C6.71522 12.5598 7.96279 12.521 7.96279 12.7832V14.3064H7.96219Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3018_125329",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 18,
			fill: "currentColor"
		})
	}) })]
});
export default SvgUsersInvited;
